import { useCallback } from "react";
import YesNoConfirm, {
  IYesNoConfirmProps,
} from "../components/YesNoConfirm/YesNoConfirm";
import { useModal } from "../providers/ModalProvider";

export default function useYesNoConfirm() {
  const { openModal } = useModal();

  const confirm = useCallback(
    ({
      title,
      message,
      onYes,
      opts,
    }: Pick<IYesNoConfirmProps, "title" | "message" | "opts" | "onYes">) =>
      openModal((props) => (
        <YesNoConfirm
          title={title}
          message={message}
          onYes={onYes}
          opts={opts}
          {...props}
        />
      )),
    []
  );

  return confirm;
}
